import {PanelElement} from "../elements/PanelElement";
import {userDataModule} from "../../modules/UserDataModule";


export class DonationPanel extends PanelElement {
    isFlowSuccess() {
        return userDataModule.isDonor();
    }
}
